/* eslint-disable max-classes-per-file */
import { Serializable, jsonProperty } from "ts-serializable"

class ModelCallStatus extends Serializable {
  @jsonProperty(String, null)
  codResult = ""

  @jsonProperty(String, null)
  descResult = ""
}

class ModelDetailInfo extends Serializable {
  @jsonProperty(String, null)
  codModelo = ""

  @jsonProperty(String, null)
  descModelo = ""

  @jsonProperty(String, null)
  descModeloStd = ""

  @jsonProperty(String, null)
  descCategoriaMtc = null

  @jsonProperty(String, null)
  codModeloApeseg = null

  @jsonProperty(String, null)
  codModeloAPESEG = null
}

class ModelDetail extends Serializable {
  @jsonProperty(String, null)
  tipoRie = ""

  @jsonProperty(String, null)
  tipoVeh = ""

  @jsonProperty(String, null)
  claseVeh = ""

  @jsonProperty(String, null)
  numPue = ""

  @jsonProperty(Number, null)
  idTipoVeh = null

  @jsonProperty(String, null)
  keyTipoVeh = null

  @jsonProperty(Number, null)
  idClaseVeh = null

  @jsonProperty(String, null)
  keyClaseVeh = ""

  @jsonProperty(String, null)
  tipoTransmision = null

  @jsonProperty(ModelDetailInfo, null)
  modelo: ModelDetailInfo = new ModelDetailInfo()

  get codModelo() {
    return this.modelo.codModelo
  }

  get codModeloAPESEGcodModelo() {
    return this.modelo.codModeloAPESEG
  }

  get descCategoriaMtc() {
    return this.modelo.descCategoriaMtc
  }

  get descModelo() {
    return this.modelo.descModelo
  }

  get descModeloStd() {
    return this.modelo.descModeloStd
  }
}
class Model extends Serializable {
  @jsonProperty(ModelCallStatus, null)
  resultado: ModelCallStatus = new ModelCallStatus()

  @jsonProperty([ModelDetail], null)
  vehiculos: Array<ModelDetail> = []
}

export { Model, ModelCallStatus, ModelDetail, ModelDetailInfo }
